var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input',{class:[
    '[&>.icon]:w-24px [&>.icon]:hover:text-primary-10 [&>.icon]:text-gray-5 color-regular-grey',
    {
      '[&>.icon]:!text-primary-10': _vm.isFocus,
      '[&>.icon]:h-32px': _vm.size === 32,
      '[&>.icon]:h-40px': _vm.size === 40,
      '[&>.icon]:right-16px': _vm.iconRight,
      '[&>.icon]:left-16px': !_vm.iconRight,
    },
  ],attrs:{"icon":!_vm.iconRight ? 'magnify' : '',"iconRight":_vm.iconRight ? 'magnify' : '',"value":_vm.value,"placeholder":_vm.$t('search'),"customClass":_vm.customClassStr},on:{"focus":function($event){_vm.isFocus = true},"blur":function($event){_vm.isFocus = false},"input":(value) => (_vm.needDebounce ? _vm.debounceSearch(value) : _vm.onSearch(value))},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onEnter.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }